import { SectionGroup } from '@sleepstation/components'
import { CopyParagraph } from '@sleepstation/components-copy'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import TestimonialSimpleList from '../TestimonialSimpleList'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({ spacing: LAYOUT_SPACING.XX_LARGE })``

const Body = styled.div``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const TestimonialsSimple = ({ title, body, items, subtitleTemplate }) => (
  <Layout>
    <SectionGroup title={title} isClose>
      <CopyParagraph>{body}</CopyParagraph>
    </SectionGroup>
    <Body>
      <TestimonialSimpleList
        testimonials={items}
        subtitleTemplate={subtitleTemplate}
      />
    </Body>
  </Layout>
)

TestimonialsSimple.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  subtitleTemplate: PropTypes.string,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
}

TestimonialsSimple.defaultProps = {
  subtitleTemplate: undefined,
}

export default TestimonialsSimple
